import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    const prev = prevPathRef.current;
    prevPathRef.current = pathname;
    
    const isCatalogNav = (path: string) => path === '/' || path.startsWith('/catalogo');
    
    if (isCatalogNav(prev) && isCatalogNav(pathname)) {
      return;
    }
    
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;